var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack } from "@fluentui/react";
import { useCallback, useState } from "react";
import { useClasses } from "../../utils/useClasses";
import { FormControl } from "./FormControl";
import { FormDescriptionControl } from "./FormDescriptionControl";
import { FeedbackType, FormProgressControl, FormStatus } from "./FormProgressControl";
var getClasses = function () { return ({
    descriptions: {
        paddingBottom: 16,
    },
    forms: {
        paddingBottom: 16,
    },
    progresses: {
        paddingBottom: 24,
    }
}); };
export var SectionFormControl = function (props) {
    var sections = props.sections, currentSection = props.currentSection, onNextSection = props.onNextSection, _onSubmit = props.onSubmit, formProps = props.formProps, progressProps = props.progressProps;
    var classes = useClasses(getClasses);
    var _a = useState((currentSection && sections.findIndex(function (v) { return v.id === currentSection; })) || 0), currentPos = _a[0], setCurrentPos = _a[1];
    var _b = useState(sections.length), limitPos = _b[0], setLimitPos = _b[1];
    var _c = useState(), feedback = _c[0], setFeedback = _c[1];
    var _d = useState(FormStatus.NONE), status = _d[0], setStatus = _d[1];
    var current = sections[currentPos];
    var onSubmit = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setStatus(FormStatus.SUBMITTING);
                    _a = setFeedback;
                    return [4, (_onSubmit === null || _onSubmit === void 0 ? void 0 : _onSubmit())];
                case 1:
                    _a.apply(void 0, [_b.sent()]);
                    setStatus(FormStatus.SUBMITTED);
                    return [2];
            }
        });
    }); }, [_onSubmit]);
    var onNext = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (status === FormStatus.SUBMITTED || status === FormStatus.SUBMITTING) {
                setCurrentPos(currentPos + 1);
                return [2];
            }
            setStatus(FormStatus.PROCESSING);
            setLimitPos(currentPos);
            return [2, Promise.resolve(onNextSection === null || onNextSection === void 0 ? void 0 : onNextSection(current.id))
                    .then(function (fb) {
                    setStatus(FormStatus.NONE);
                    setLimitPos(sections.length);
                    setFeedback(fb || undefined);
                    if (!fb)
                        setCurrentPos(currentPos + 1);
                })
                    .catch(function (err) {
                    console.error(err);
                    setFeedback({
                        message: "Something went wrong.",
                        type: FeedbackType.ERROR,
                    });
                })];
        });
    }); }, [currentPos, onNextSection, current, status, sections.length]);
    var onPrev = useCallback(function () {
        setCurrentPos(currentPos - 1);
    }, [currentPos]);
    return (_jsxs(Stack, __assign({ tokens: { childrenGap: 16 } }, { children: [_jsx(FormDescriptionControl, __assign({ className: classes.descriptions, description: current.description }, current.descriptionProps), void 0), _jsx(FormControl, __assign({ className: classes.forms, hintRequired: true }, formProps, { children: typeof current.items === "function" ? current.items(current.id) : current.items }), void 0), _jsx(FormProgressControl, __assign({ className: classes.progresses, currentPos: currentPos, sectionCount: sections.length, info: current.actionInfo, status: status, disableNext: current.status !== SectionStatus.FULFILLED || currentPos === limitPos ? true : undefined, onNext: onNext, onPrev: onPrev, onSubmit: onSubmit, feedback: feedback }, progressProps), void 0)] }), void 0));
};
export var SectionStatus;
(function (SectionStatus) {
    SectionStatus["FULFILLED"] = "fulfilled";
    SectionStatus["INCOMPLETE"] = "incomplete";
})(SectionStatus || (SectionStatus = {}));
//# sourceMappingURL=SectionFormControl.js.map